import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=5b891bf7&"
import script from "./TeamForm.vue?vue&type=script&lang=js&"
export * from "./TeamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b891bf7')) {
      api.createRecord('5b891bf7', component.options)
    } else {
      api.reload('5b891bf7', component.options)
    }
    module.hot.accept("./TeamForm.vue?vue&type=template&id=5b891bf7&", function () {
      api.rerender('5b891bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/teams/TeamForm.vue"
export default component.exports